import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { config } from '../config/config';

@Injectable({ providedIn: 'root' })
export class AudioService {
  private apiUrl = `${config.examApiBaseUrl}/text-to-audio-azure`;
  private lastRequestTime = 0;
  private isRequestInProgress = false;
  private cooldown = 3000;

  constructor(private http: HttpClient) {}

  textToAudio(text: string, language: string): Observable<any> {
    const now = Date.now();

    if (this.isRequestInProgress || now - this.lastRequestTime < this.cooldown) {
      return throwError(() => new Error('Please wait before making another request.'));
    }

    this.isRequestInProgress = true;
    this.lastRequestTime = now;

    return this.http.post(this.apiUrl, { text, language }, { responseType: 'blob' }).pipe(
      finalize(() => {
        this.isRequestInProgress = false;
      })
    );
  }
}
